
import { Circle, Color, Engine, Scene, ScreenElement, Sprite, SpriteSheet, Timer } from 'excalibur';
import { Resources } from '../resources';

import { SongPlayer } from '../actors/song_player';
import { LevelOne } from './level-one/level-one';

/**
 * Managed scene
 */
export class TitleScene extends Scene {
  public onInitialize(engine: Engine) {
    const titleSprite = new Sprite({
        image: Resources.title,
    })

    const spriteAspectRatio = titleSprite.width / titleSprite.height;

    if (engine.drawWidth / engine.drawHeight > spriteAspectRatio) {
        titleSprite.destSize = {
            width: engine.drawWidth,
            height: engine.drawWidth / spriteAspectRatio,
        }
    } else {
        titleSprite.destSize = {
            width: engine.drawHeight * spriteAspectRatio,
            height: engine.drawHeight,
        }
    }

    const title  = new ScreenElement({
        x: engine.drawWidth / 2 - titleSprite.destSize.width / 2,
        y: engine.drawHeight / 2 - titleSprite.destSize.height / 2,
        width: titleSprite.destSize.width,
        height: titleSprite.destSize.height,
    });

    title.graphics.use(titleSprite);

    const player = new SongPlayer(Resources.menuIntro, Resources.menuLoop);

    title.on('pointerup', () => {
        player.stop();
        this.engine.remove(this);
        this.engine.add('levelOne', new LevelOne())
        this.engine.goToScene('levelOne');
    });

    this.add(title);
    
    this.add(player);
    
  }
}
